module.exports = __webpack_public_path__ + "static/img/fengkong.cb37493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/fengkong.jpg
// module id = GaYi
// module chunks = 7